import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import NotFound from '@components/NotFound';

import { AssessmentResultProvider } from '@contexts/assessment-result';

import AssessmentDrilldown from '@views/Assessments/Bha/Drilldown';
import AppointmentsDrilldown from '@views/Records/Appointments/Drilldown';
import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  default: {
    id: 'assessmentDrilldown.title.default',
    defaultMessage: 'Assessment',
  },
  dha: {
    id: 'assessmentDrilldown.title.dha',
    defaultMessage: 'Digital Health Assessment',
  },
  other: {
    id: 'assessmentDrilldown.title.other',
    defaultMessage: 'Assessment',
  },
});

export default function HealthAssessmentResult({ params }: PageProps) {
  const { formatMessage } = useIntl();
  const { id, type } = params;

  if (!type || !('id' in params)) {
    return <NotFound />;
  }

  switch (type) {
    case 'other':
      return <AppointmentsDrilldown {...params} />;
    case 'dha':
    default:
      return (
        <MainWrapper
          backgroundIcon="logo"
          friendlyName={formatMessage(messages.dha)}
          showBreadcrumb={false}
          showHeader
          title={formatMessage(messages.dha)}
        >
          <AssessmentResultProvider id={id}>
            <AssessmentDrilldown shareContext={{ assessment_id: id }} />
          </AssessmentResultProvider>
        </MainWrapper>
      );
  }
}
